import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import "./post-detail-page.css";

const replyData = [
  {
    id: 1,
    winner: true,
    type: "nailed",
    name: "Priya R. ",
    time: "Today",
    text: "Used the pasta water trick exactly like you said - went from grainy to silky the second time around. 12 minutes flat.",
  },
  {
    id: 2,
    winner: false,
    type: "twist",
    name: "James L.",
    time: "3 hours ago",
    text: "Added a little lemon zest at the end - cuts through the richness nicely. Still very much your recipe though.",
  },
  {
    id: 3,
    winner: false,
    type: "almost",
    name: "Sofia M.",
    time: "5 hours ago",
    text: "First attempt clumped on me but I think I added the cheese too fast. Trying again tomorrow with your slow whisk tip.",
  },
  {
    id: 4,
    winner: false,
    type: "nailed",
    name: "Chen W.",
    time: "Yesterday",
    text: "Did not expect 3 ingredients to taste this good. My kitchen smells like a trattoria right now.",
  },
];

const filters = [
  { key: "all", label: "All 47" },
  { key: "nailed", label: "Nailed it" },
  { key: "twist", label: "My twist" },
  { key: "almost", label: "Almost" },
];

const ingredients = [
  { id: "spaghetti", label: "200g spaghetti", checked: false },
  { id: "pecorino", label: "100g Pecorino Romano, finely grated", checked: false },
  { id: "pepper", label: "2 tsp coarse black pepper", checked: false },
  { id: "water", label: "Reserved pasta water", checked: true },
];

const classForType = (type) => {
  if (type === "nailed") return "nailed";
  if (type === "twist") return "twist";
  return "almost";
};

const labelForType = (type) => {
  if (type === "nailed") return "Nailed it";
  if (type === "twist") return "My twist";
  return "Almost";
};

const PostDetailPage = () => {
  const [liked, setLiked] = useState(true);
  const [likeCount, setLikeCount] = useState(142);
  const [followAuthor, setFollowAuthor] = useState(false);
  const [followCreator, setFollowCreator] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const [ingredientState, setIngredientState] = useState(
    ingredients.reduce((acc, item) => {
      acc[item.id] = item.checked;
      return acc;
    }, {})
  );

  const filteredReplies = useMemo(() => {
    if (activeFilter === "all") {
      return replyData;
    }
    return replyData.filter((reply) => reply.type === activeFilter);
  }, [activeFilter]);

  const toggleLike = () => {
    setLiked((prev) => {
      const next = !prev;
      setLikeCount((count) => count + (next ? 1 : -1));
      return next;
    });
  };

  const toggleIngredient = (id) => {
    setIngredientState((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="nmpd-root">
      <div className="nmpd-app">
        <aside className="nmpd-sidebar">
          <div className="nmpd-brand">
            <img src={logo} alt="Nemonto" />
          </div>

          <nav>
            <Link className="nmpd-nav-item" to="/pages/home"><span className="nmpd-nav-label">Home</span></Link>
            <Link className="nmpd-nav-item" to="/pages/challenges-listing"><span className="nmpd-nav-label">Explore</span></Link>
            <Link className="nmpd-nav-item active" to="/pages/made-it-hub" aria-current="page"><span className="nmpd-nav-label">Made it</span></Link>
            <Link className="nmpd-nav-item" to="/pages/challenges-listing"><span className="nmpd-nav-label">Challenges</span><span className="nmpd-nav-badge">3 live</span></Link>
            <Link className="nmpd-nav-item" to="/pages/profile-other"><span className="nmpd-nav-label">Saved</span></Link>
            <Link className="nmpd-nav-item" to="/pages/post-detail"><span className="nmpd-nav-label">Messages</span><span className="nmpd-nav-badge">2</span></Link>
            <Link className="nmpd-nav-item" to="/pages/profile"><span className="nmpd-nav-label">Profile</span></Link>
          </nav>

          <button className="nmpd-post-btn">
            <span>New recipe</span>
          </button>

          <div className="nmpd-sidebar-spacer" />

          <div className="nmpd-profile-mini">
            <div className="nmpd-avatar-mini" />
            <div className="nmpd-profile-text">
              <div className="nmpd-profile-name">Priya Rajan</div>
              <div className="nmpd-profile-handle">@priyacooks</div>
            </div>
          </div>
        </aside>

        <main className="nmpd-main">
          <div className="nmpd-back-row">
            <Link to="/pages/home">Back to feed</Link>
          </div>

          <div className="nmpd-wrap">
            <div className="nmpd-author-row">
              <div className="nmpd-author-avatar" />
              <div>
                <div className="nmpd-author-name">Maria K. </div>
                <div className="nmpd-author-meta">Italian - Posted 12 min ago</div>
              </div>
              <button
                className={`nmpd-follow-btn${followAuthor ? " following" : ""}`}
                onClick={() => setFollowAuthor((prev) => !prev)}
              >
                {followAuthor ? "Following" : "Follow"}
              </button>
            </div>

            <div className="nmpd-media-box">
              <span className="nmpd-flag">Submitted to a challenge</span>
              <span className="nmpd-play">Play</span>
            </div>

            <h1 className="nmpd-title">Cacio e Pepe - nonna&apos;s version</h1>
            <p className="nmpd-desc">
              Only 3 ingredients. Takes 15 minutes. The secret is whisking the pasta water in slowly - never let the pan get too hot or the cheese will seize up on you.
            </p>

            <div className="nmpd-action-bar">
              <button className={`nmpd-action${liked ? " liked" : ""}`} onClick={toggleLike}>Like {likeCount}</button>
              <span className="nmpd-action">Comments 38</span>
              <span className="nmpd-action">Share</span>
              <span className="nmpd-action">Save</span>
              <button className="nmpd-made-btn">Made it?</button>
            </div>

            <div className="nmpd-stats">
              <div className="nmpd-stat"><b>15 min</b><span>Cook time</span></div>
              <div className="nmpd-stat"><b>2</b><span>Servings</span></div>
              <div className="nmpd-stat"><b>47</b><span>Made it</span></div>
              <div className="nmpd-stat"><b>Italian</b><span>Cuisine</span></div>
            </div>

            <section className="nmpd-section">
              <p className="nmpd-section-head">Ingredients</p>
              <div className="nmpd-ingredient-list">
                {ingredients.map((ingredient) => (
                  <button
                    key={ingredient.id}
                    className="nmpd-ingredient"
                    onClick={() => toggleIngredient(ingredient.id)}
                  >
                    <span className={`nmpd-check${ingredientState[ingredient.id] ? " checked" : ""}`} />
                    <span>{ingredient.label}</span>
                  </button>
                ))}
              </div>
            </section>

            <section className="nmpd-section">
              <p className="nmpd-section-head">Steps</p>
              <div className="nmpd-steps">
                <div className="nmpd-step"><span className="nmpd-step-num">1</span><span>Toast the cracked pepper in a dry pan for 30 seconds until fragrant. Set aside.</span></div>
                <div className="nmpd-step"><span className="nmpd-step-num">2</span><span>Boil the spaghetti one minute under package time. Reserve a full cup of starchy pasta water before draining.</span></div>
                <div className="nmpd-step"><span className="nmpd-step-num">3</span><span>Off the heat, whisk Pecorino into a splash of pasta water slowly. Build a smooth sauce.</span></div>
                <div className="nmpd-step"><span className="nmpd-step-num">4</span><span>Toss the pasta through the sauce with toasted pepper. Add more pasta water if needed.</span></div>
              </div>
            </section>

            <div className="nmpd-note">My nonna never measured anything - this is me trying to write down what her hands already knew.</div>

            <h2 className="nmpd-thread-title">Made it - 47 replies</h2>

            <div className="nmpd-filter-row">
              {filters.map((filter) => (
                <button
                  key={filter.key}
                  className={`nmpd-filter${activeFilter === filter.key ? " active" : ""}`}
                  onClick={() => setActiveFilter(filter.key)}
                >
                  {filter.label}
                </button>
              ))}
            </div>

            {filteredReplies.map((reply) => (
              <article key={reply.id} className={`nmpd-reply${reply.winner ? " winner" : ""}`}>
                {reply.winner ? <p className="nmpd-winner-tag">Challenge winner - chosen by Maria</p> : null}
                <div className="nmpd-reply-top">
                  <div className="nmpd-reply-avatar" style={{ background: reply.id === 2 ? "#AFA9EC" : reply.id === 3 ? "#FAC775" : reply.id === 4 ? "#F5C4B3" : "#9FE1CB" }} />
                  <div>
                    <div className="nmpd-reply-name">{reply.name}</div>
                    <div className="nmpd-reply-time">{reply.time}</div>
                  </div>
                  <span className={`nmpd-badge ${classForType(reply.type)}`}>{labelForType(reply.type)}</span>
                </div>
                <p className="nmpd-reply-text">{reply.text}</p>
              </article>
            ))}
          </div>
        </main>

        <aside className="nmpd-right">
          <div className="nmpd-card nmpd-center">
            <div className="nmpd-creator-avatar" />
            <p><strong>Maria K.</strong></p>
            <p>@mariakcooks - Founding Creator</p>
            <button
              className={`nmpd-follow-btn${followCreator ? " following" : ""}`}
              onClick={() => setFollowCreator((prev) => !prev)}
            >
              {followCreator ? "Following" : "Follow Maria"}
            </button>
          </div>

          <div className="nmpd-card nmpd-cart">
            <p>Shop this recipe</p>
            <p className="nmpd-cart-title">Add Pecorino and spaghetti to your cart</p>
            <button className="nmpd-cart-btn" type="button">Order ingredients</button>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default PostDetailPage;
